<template>
  <div class="mask">
    <div class="maskA" >
      <div class="maskAA">
        <p v-if="tianbaoType ==2">专业分组 : {{obj.obj.group_name}}组</p>
        <p v-if="tianbaoType ==0">专业详情</p>
        <img @click="Submit()" src="../../src/assets/img/cha.png" />
      </div>
      <div class="two_A">
        <div class="T_title0_A">概率</div>
        <div class="T_title1_A">专业名称</div>
        <div class="T_title2_A">计划数</div>
        <div class="T_title8_A">
          <div class="T_title8bot_A">
            <div :style="{width:showList[0]}">年份</div>
            <div :style="{width:showList[1]}">录取/计划</div>
            <div :style="{width:showList[2]}">最低分</div>
            <div :style="{width:showList[3]}">等位分</div>
            <div :style="{width:showList[4]}" v-if="userInfo.userRole == 3||userInfo.userRole == 2">等效分</div>
            <div :style="{width:showList[5]}">最低位次</div>
            <div :style="{width:showList[6]}"
             style="display: flex; flex-direction: row;align-items: center;justify-content: center;">分差/位差<div style="border: #ffffff 1px solid;
            border-radius: 10px;width: 18px;height: 18px;line-height: 18px;justify-content: center; font-weight: 800;margin-left: 5px;
            ">?</div></div>
          </div>
        </div>
        <div class="T_title9_A">操作</div>
      </div>
      <div class="ANAN3">
        <div class="three_A" v-loading="loading" element-loading-text="数据加载中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="#ebeef5"
     >
          <div class="three_for_A" v-for="(item, index) in list" :key="index" >
            <div class="Cont_A Cont0_A">
              <div>
                <rate :rate="item.rate" :newMajor="item.list!=null&&item.list!=0"></rate>
              </div>
            </div>
            <div class="Cont_A Cont1_A">
              <div class="Cont_Nr_A">
                <div class="Cont_Nr_A_A" style="justify-content: space-between;">
                  <h3>{{ item.obj.major_name }}
                  </h3>
                  <imajor :item="item"></imajor>
                </div>

                <div style="display: flex;justify-content: flex-start;font-size: 12px;">
                  <div class="Cont_Nr_A_A"
                   style="margin-right: 30px;"
                   v-if="getempty(item.obj.major_code)!='--'&&$utils.getlocalStorage('showcode')">
                    专业代码 : <b style="color: #f66464;">{{ item.obj.major_code }}</b></div>
                  <div class="Cont_Nr_A_A" v-if="item.obj.tuition!=null&&item.obj.tuition!=''">
                    学费：<b style="color: #f66464;">{{ item.obj.tuition }}</b>
                  </div>
                </div>

                <div class="Cont_Nr_A_A" v-if="item.major!=null">

                </div>
                <el-tooltip effect="dark" placement="right" v-if="item.obj.major_info!=null&&item.obj.major_info!=''">
                  <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
                    {{ item.obj.major_info}}
                  </div>
                  <p style="font-size: 12px;">
                    {{ item.obj.major_info.length>=22?item.obj.major_info.substring(0,22)+'...':item.obj.major_info }}
                  </p>
                </el-tooltip>
              </div>
            </div>
            <div class="Cont_A Cont2_A">
              <p>{{ getempty(item.obj.plan_num) }}</p>

              <p>
              <span v-if="item.obj.planflag>=0" style="color: #05e805;">增  </span>
              <span v-if="item.obj.planflag<0" style="color: #f66464;">减  </span>
              {{Math.abs(item.obj.planflag)}}人
              </p>
            </div>
            <div class="Cont_A Cont8_S">
              <div class="Cont8_A Cont8_AA" v-for="(data, index2) in $utils.getscore(item.list,scoreyear)" :key="index2+'1'">
                <div class="Cont8_B" :style="{width:showList[0]}">{{ data.scoreYear }}</div>
                <div class="Cont8_B" :style="{width:showList[1]}">{{ getempty(data.scorePlanNum) +'/'+ getempty(data.scorePlanNum)  }}</div>
                <div class="Cont8_B" :style="{width:showList[2]}">{{ getempty(data.scoreMin) }}</div>
                <div class="Cont8_B" :style="{width:showList[3]}">{{ getempty(data.spare2) }}</div>
                <div class="Cont8_B" :style="{width:showList[4]}" v-if="userInfo.userRole == 3||userInfo.userRole == 2" >{{ getempty(data.spare1) }}</div>
                <div class="Cont8_B" :style="{width:showList[5]}">{{ data.scoreMinRank }}</div>

                <div class="Cont8_B" :style="{width:showList[6]}">
                <span  :style="{color:$utils.getScorecolor(score.score,data.spare2,1)}">{{ $utils.getScoreCha(score.score,data.spare2,1) }}</span>
                /<span  :style="{color:$utils.getScorecolor(score.scoreRank,data.scoreMinRank,0)}">{{ $utils.getScoreCha(score.scoreRank,data.scoreMinRank,0) }}</span>
                </div>
              </div>

            </div>

            <div class="Cont_A Cont9_S">
              <div v-if="!$utils.showflag(showtype)" :class="{Cont9_BBB:item.checked,Cont9_AAA:!item.checked}"
                @click="selectMajor(index,item.obj.plan_id)">
                <p>{{item.checked?'已选专业':'选择专业'}}</p>
              </div>
              <div v-else
                :class="{Cont9_BBB:ids.indexOf(item.obj.plan_id)!=-1,Cont9_AAA:ids.indexOf(item.obj.plan_id)==-1}"
                @click="guanzhu(item.obj.plan_id,ids.indexOf(item.obj.plan_id))">
                <p>{{ids.indexOf(item.obj.plan_id)!=-1?'已关注':'+关注'}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="bottijiao" v-if="!$utils.showflag(showtype)">
          <p @click="Submit()">提交已选<span v-if="ids.length!=0">({{ids.length}})</span></p>
        </div>
      </div>
    </div>
    <toast :title="title" :message="message" v-if="toastflag"
    quxiaoName="否" quitName="是" fun="confirm" @confirm="confirm" @close="quxiaofun"
    @quxiao="quxiao" :fun="fun" :flag="toastflag" :btn="que"></toast>
  </div>
</template>

<script>
  import rate from './rateInfo.vue'
   import toast from './toast.vue'
   import imajor from "../components/imajor.vue";
  export default {
    components: {
      rate,
      toast,
      imajor
    },
    props: {
      obj: {
        type: Object
      },
      type: {
        type: String
      },
      selectids: {
        type: Object
      },
      showtype: {
        type: String
      },
      datatype: {
        type: String
      },
      querykey: {
        type: String
      },
      jhflag:{
        type:Boolean
      }

    },
    data() {
      return {
        ids: [],
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        scoreInfo:this.$utils.getlocalStorage('scoreInfo'),
        userInfo:this.$utils.getlocalStorage('userInfo'),
        userZhiYuanBatch:this.$utils.getlocalStorage('userZhiYuanBatch'),
        score: this.$utils.getlocalStorage("scoreInfo"),
        list: [],
        title: "",
        fun: 'quxiao',
        message: "",
        toastflag: false,
        que: 'que',
        tishi: 0,
        totype: "wyw",
        loading:false,
        scoreyear:2021,
        index:-1,
        id:null,
        showList:[]


      }
    },
    methods: {
      Submit() {
        let yixuan = []
        this.list.forEach(function(item) {
          if (item.checked) {
            yixuan.push({
              majorName: item.obj.major_name,
              majorId: item.obj.major_id,
              majorCode: item.obj.major_code,
              majorInfo: item.obj.major_info,
              planNum: item.obj.plan_num,
              planYear: item.obj.plan_year,
              studyMoney: item.obj.tuition,
              tuition: item.obj.tuition,
              planflag: item.obj.planflag,
              rate: item.rate,
              id: item.obj.plan_id,
              flag: true,
              // list:item.list,
              score:item.list,
              major:item.major
            });
          }
        })

        this.$emit('close', {
          ids: this.ids,
          yixuan: yixuan
        });
      },
      getData() {
        let _this = this;
        this.loading = true;
        if (this.tianbaoType == 2) {
			let queryObj = {
              userArea: this.$utils.getlocalStorage("scoreInfo").scoreArea+'',
              tianbaoType: this.tianbaoType + "",
              id: this.obj.dataid,
              data_type: this.type,
              queryType: this.datatype,
              jhflag:this.jhflag,
              batch:this.userZhiYuanBatch.provincialBatch,
              scoretype:this.userZhiYuanBatch.provincialSubject,
              userScore:this.scoreInfo.score
            }
			if(this.userInfo.userRole == 3||this.userInfo.userRole == 2){
			  queryObj.userId = this.userInfo.userId
			}
          this.$req.queryZyByTypechildLimit({
            queryObj: queryObj,
            queryKey:this.querykey,
          }).then(function(response) {
            _this.loading = false;
            if (_this.selectids != null) {
              response.data.forEach(function(item) {
                if (_this.selectids.ids.indexOf(item.obj.plan_id) != -1) {
                  item.checked = true
                }
              })
            }
            if(response.year){
              _this.scoreyear = response.year
            }
            _this.list = response.data
          })
        } else if (this.tianbaoType == 0) {
			let queryObj = {
              userArea: this.$utils.getlocalStorage("scoreInfo").scoreArea,
              batch: this.$utils.getlocalStorage('userZhiYuanBatch').provincialBatch,
              sun_id: this.obj.obj.plan_id,
              scoretype: this.$utils.getlocalStorage('scoreInfo').scoreSubject,
              userScore: this.$utils.getlocalStorage("scoreInfo").score,
              jhflag:this.jhflag
            }
			if(this.userInfo.userRole == 3||this.userInfo.userRole == 2){
			  queryObj.userId = this.userInfo.userId
			}
          this.$req.majorTianbao({
            pageSize: _this.pageSize,
            pageNum: _this.pageNum,
            queryObj: queryObj,
          }).then(function(response) {
            _this.loading = false;
            response.data.forEach(function(item) {
              if (_this.selectids != null) {
                if (_this.selectids.ids.indexOf(item.obj.plan_id) != -1) {
                  item.checked = true
                }
              }
            })
            if(response.year){
              _this.scoreyear = response.year
            }
            _this.list = response.data
          })
        }
      },
      guanzhu(id, index) {
        let _this = this;
        let obj = this.$utils.getlocalStorage("userCang")
        if (index == -1) {
          _this.$req.insert("collectionTable", {
            dataType: 4,
            dataId: id,
            userId:this.userInfo.userId
          }).then(function(resp) {
            if (resp.status == 0) {
              _this.ids.push(id);
              obj.majorscore = _this.ids
              _this.$utils.setlocalStorage("userCang", obj);
            }
          })
        } else {
          _this.$req.batchDelete("collectionTable", {
            data_type: 4,
            data_id: id
          }).then(function(resp) {
            if (resp.status == 0) {
              _this.ids.splice(index, 1);
              obj.majorscore = _this.ids
              _this.$utils.setlocalStorage("userCang", obj);
            }
          })
        }
      },
      quxiao() {
        this.toastflag = false;
      },
      quxiaofun(){
        this.toastflag = false;
        this.Submit()
      },
      confirm(a){
         this.toastflag = false;
        let _this = this;
        let map = this.$utils.getlocalStorage("ZhiYuan" + this.type)
        let index = this.index
        let id = this.id
        this.list[index].checked = !this.list[index].checked
        if (this.list[index].checked) {
          this.ids.push(id)
        } else {
          this.ids.splice(this.ids.indexOf(id), 1);
        }
      },
      selectMajor(index, id) {
        let _this = this;
        let map = this.$utils.getlocalStorage("ZhiYuan" + this.type)
        this.index = index
        this.id = id
        if(!this.list[index].checked&&this.ids.length!=0){
          this.title = '温馨提醒';
          this.message = '专业最多可选择“'+	this.$utils.getlocalStorage("userZhiYuanBatch").majornum+"”(个)，您确定继续选择吗，点“是”继续选择，点“否”返回院校（组）志愿"
          if(this.$utils.getlocalStorage("userZhiYuanBatch").majornum!=undefined){
           if(this.ids.length==	this.$utils.getlocalStorage("userZhiYuanBatch").majornum){
             this.que = 'que,qu';
             this.fun = 'confirm'
             this.toastflag = true;
             return ;
           }
          }
        }

        this.list[index].checked = !this.list[index].checked
        if (this.list[index].checked) {
          this.ids.push(id)
        } else {
          this.ids.splice(this.ids.indexOf(id), 1);
        }
      },
      getempty(str) {
        if (str == null || str == '') {
          return '--';
        }
        return str;
      },
    },
    created() {
      console.log(this.obj)
      if (this.selectids != null) {
        this.ids = this.selectids.ids
      }
      if (this.$utils.showflag(this.showtype)) {
        this.ids = this.$utils.getlocalStorage("userCang")[this.showtype]
      }
      if(this.userInfo.userRole == 2||this.userInfo.userRole == 3){
        this.showList = ['55px','60px','55px','55px','55px','80px','110px'];
      } else {
        this.showList = ['60px','65px','60px','60px','0px','90px','134px'];
      }
      this.getData();
    }
  }
</script>

<style scoped>
  /* 遮罩层  ↓ */
  .mytag{
    height: 18px;
    line-height: 16px;
    padding: 0 5px;
    margin-left: 10px;
  }
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1003;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .loadingc{
    font-size: 20px;
  }
  .el-loading-spinner i {
      color: #f66464;
      font-size: 25px;
  }
  .el-loading-spinner .el-loading-text {
      color: #f66464;
      margin: 3px 0;
      font-size: 14px;
  }

  .maskA {
    width: 1080px;
    height: 90vh;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 1080px;
    height: 45px;
    background-image: url("../../src/assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 5px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN3 {
    width: 100%;
    padding: 0;
    padding-bottom: 10px;
    height: calc(100% - 170px);
    overflow-y: scroll;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .two_A {
    width: 1050px;
    height: 46px;
    background: #f66464;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin: auto;
    margin-left: 9px;
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    opacity: 1;
  }

  .T_title0_A {
    width: 95px;
    text-align: center;
    line-height: 46px;
    color: #ffffff;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title1_A {
    width: 300px;
    text-align: center;
    line-height: 46px;
    color: #ffffff;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title2_A {
    width: 65px;
    text-align: center;
    line-height: 46px;
    color: #ffffff;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8_A {
    width: 470px;
    text-align: center;
    line-height: 46px;
    color: #ffffff;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title9_A {
    width: 120px;
    text-align: center;
    color: #ffffff;
    line-height: 46px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8bot_A {
    display: flex;

    justify-content: space-evenly;
  }

  .T_title8bot_A div {
    color: #ffffff;
  }

  .three_A {
    width: 1050px;
    height: 100%;
    margin-top: 11px;
    margin-bottom: 55px;
    margin: auto;
    min-height: 400px;
    padding-bottom: 20px;
    box-sizing: border-box;
  }

  .three_for_A {
    display: flex;
    width: 100%;
    height: 100px;
    /* border: 1px solid #ebe9e9;
    border-radius: 10px;
    margin-bottom: 5px;
    margin-top: 5px; */
    border: 1px solid #c0c4cc;
    border-radius: 10px;
    margin-bottom: 9px;
    margin-top: 9px;
    flex-direction: row;
    align-items: center;
  }

  .Cont_A {
    border-right: 1px solid #ebe9e9;
  }

  .Cont0_A {
    width: 95px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* padding-top: 14px; */
    /* padding-left: 0px; */
    box-sizing: border-box;
  }

  .Cont1_A {
    width: 300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-left: 15px;
    box-sizing: border-box;
  }

  .Cont2_A {
    width: 65px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* padding-top: 14px; */

    text-align: center;
    /* padding-left: 30px; */
    box-sizing: border-box;
  }

  .Cont2_A p {
    /* color: #f66464; */
  }

  /* .Cont_Nr_A {
    display: flex;
    flex-direction: column;
    justify-content: center;
  } */
  .Cont1_A .Cont_Nr_A span {
    /* color: #f66464; */
  }

  .Cont1_A .Cont_Nr_A h3 {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #29a7e1;
    /* margin-bottom: 10px; */
  }


  .Cont_Nr_A p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #999999;
  }

  .Cont_Nr_A_A {
    display: flex;
    align-items: center;
    margin: 0 0;
  }

  /* 未关注 */
  .weiguanzhuA {
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 62px;
    height: 24px;
    background-image: url(../../src/assets/img/weiguanzhu.png);
    background-size: 100% 100%;
  }

  .weiguanzhuA img {
    width: 13px;
    height: 14px;
  }

  .weiguanzhuA p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
  }

  /* 未关注 */
  /* 已关注 */
  .weiguanzhuB {
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 62px;
    height: 24px;
    background-image: url(../../src/assets/img/yiguanzhu.png);
    background-size: 100% 100%;
  }

  .weiguanzhuB img {
    display: none;
  }

  .weiguanzhuB p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  /* 已关注 */
  .Cont8_S {
    width: 470px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: none;
  }

  .Cont8_A {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    border-right: 1px solid #ebe9e9;
  }

  .Cont8_AA {
    font-size: 13px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29a7e1;
  }

  .Cont8_B {
    width: 20%;
    height: 100%;
    line-height: 100%;
    border-bottom: 1px solid #ebe9e9;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .Cont9_S {
    width: 120px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
  }

  /* 未选择专业  */
  .Cont9_S .Cont9_AAA {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url("../../src/assets/img/wxzhuanye.png");
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  .Cont9_S .Cont9_AAA p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
  }

  /* 未选择专业  */
  /* 点击选择专业  */
  .Cont9_S .Cont9_BBB {
    display: flex;
    justify-content: center;
    width: 92px;
    height: 36px;
    background-image: url("../../src/assets/img/yxzhuanye.png");
    background-size: 92px 36px;
    align-items: center;
    cursor: pointer;
  }

  .Cont9_S .Cont9_BBB p {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  /* 点击选择专业  */
  .bottijiao {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px;
    background: rgb(255, 255, 255);
    box-shadow: 0px -1px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bottijiao p {
    background: linear-gradient(131deg, #FE9603 0%, #F53824 100%);
    border-radius: 5px;
    padding: 7px 18px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    cursor: pointer;
  }

  .mask_nr {
    padding: 20px;
    box-sizing: border-box;
  }

  /* 我写的！！！！！！！ */
  .mask_nr {
    width: 100%;
    height: calc(100% - 64px);
    padding: 20px;
    box-sizing: border-box;
    overflow: auto;
  }

  .ANAN1 {
    width: 100%;
    height: calc(100% - 64px);
  }
</style>



// WEBPACK FOOTER //
// src/components/zyCollegeMajor.vue